import { render, staticRenderFns } from "./historyInformation.vue?vue&type=template&id=338fe976&scoped=true&"
import script from "./historyInformation.vue?vue&type=script&lang=js&"
export * from "./historyInformation.vue?vue&type=script&lang=js&"
import style0 from "./historyInformation.vue?vue&type=style&index=0&id=338fe976&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338fe976",
  null
  
)

export default component.exports